import React from 'react';
import { Typography } from '@mui/material';
import BackdropDialog from 'common/components/BackdropDialog';
import { getTranslation } from 'common/modules/translations';
import { Trans } from 'react-i18next';
import { useTranslation } from 'services/localization/useTranslation';
import { OrderProduct } from 'common/types';
import { getProductNameWithVariant } from 'common/utils/productUtils';

interface Props {
	isOpen: boolean;
	isMobile: boolean;
	overbookedProducts: OrderProduct[];
	onClose: () => void;
	confirmCallback: () => void;
}
const OverbookingDialog = (props: Props) => {
	const { isOpen, isMobile, overbookedProducts, onClose, confirmCallback } = props;
	const { t, lang } = useTranslation();

	const overbookedProductNames = overbookedProducts.map((product) =>
		getProductNameWithVariant(
			getTranslation(product.name, lang),
			product.variant || null,
			lang,
			product,
		),
	);

	return (
		<BackdropDialog
			isOpen={isOpen}
			onClose={onClose}
			fullScreen={isMobile}
			label={t('newRental.confirmOverbooking', 'Confirm overbooking') + '?'}
			variant={'danger'}
			body={
				<Typography variant="body1">
					<Trans
						i18nKey="newRental.confirmOverbookingText2"
						defaults="Not enough <bold>{{products}}</bold> available. Do you still want to confirm the order?"
						values={{
							products: overbookedProductNames.join(', '),
						}}
						components={{
							bold: <b />,
						}}
					/>
				</Typography>
			}
			confirm={{
				label: t('common:actions.confirm'),
				callback: confirmCallback,
				closeAfterDone: true,
			}}
			cancel={{
				label: t('common:actions.goBack'),
			}}
		/>
	);
};

export default OverbookingDialog;
